export const toTitleCase = (s: string | number | undefined | null) => {
  if (s === null || s === undefined) return '';
  return `${s}`
    .replace(/([A-Z]+)/g, ' $1')
    .replace(/^ /, '')
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toUpperCase() : word.toUpperCase()
    )
    .replace(/([_][a-z])/gi, ($1) => {
      return $1.toUpperCase().replace('_', ' ');
    })
    .replace(/[^a-zA-Z0-9\- ]/g, ' ')
    .replace(/\s\s+/g, ' ')
    .trim();
};
